<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/CHR6HA/tc-custom/9781426846526.jpg?1726617394416" alt="This image is the cover for the book Ransom Bride"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Ransom Bride
      </h1>
      <p class="bookDescription body article font2">
        <p>Once a galley slave, now a Venetian merchant prince, Lorenzo Santorini is driven to seek revenge on his Corsair captor. He spares no time for softer emotions such as love. <br/><br/>Yet when English beauty Kathryn Rowlands appeals for help in finding a friend lost to pirates, Lorenzo struggles to maintain his cold detachment. Kathryn awakens more than lustful thoughts. She stirs deep feelings that he has long forgotten. He must take drastic steps to protect her from his sworn enemy….<br/><br/></p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Anne Herries
      </h2>
      
      <p class="authorDescription body article">Linda Sole was started writing in 1976 and writing as Anne Herries, won the 2004 RNA Romance Award and the Betty Neels Trophy. Linda loves to write about the beauty of nature, though they are mostly about love and romance. She writes for her own enjoyment and loves to give pleasure to her readers. In her spare time, she enjoys watching the wildlife that visits her garden. Anne has now written more&#160; fifty books for HMB.&#160; You can visit her website at: www.lindasole.co.u</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Harlequin
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?a54552e0